import { j as l } from "../../../node_modules/react/jsx-runtime.js";
import { memo as D, useState as o } from "react";
import { clsx as w } from "../../../node_modules/clsx/dist/clsx.m.js";
import K from "../../atoms/Button/Button.js";
import d from "./PageHeader.module.scss.js";
import t from "../../atoms/Breadcrumb/Breadcrumb.js";
import { Typography as z } from "../../atoms/Typography/Typography.js";
import N from "../../atoms/Skeleton/Skeleton.js";
import p from "../BadgeGroup/BadgeGroup.js";
import M from "../Dropdown/Dropdown.js";
import T from "../../atoms/Tooltip/Tooltip.js";
import C from "../../atoms/Icon/Icon.js";
import { Avatar as W } from "../../atoms/Avatars/Avatar.js";
const u = ({
  breadcrumbData: m,
  backButton: c,
  title: x,
  badgeGroup: f,
  actionMenu: H,
  actionPrimaryButton: O,
  actionSecondaryButton: E,
  subTitleList: y,
  className: $,
  avatarEditable: q,
  avatarEditForm: k,
  avatarLogo: I,
  loading: A,
  testId: F,
  autoComplete: J = "off",
  dropDown: s,
  pageHeaderBody: Q,
  onAvatarChange: V,
  ...X
}) => {
  const R = document.body.getAttribute("dir") === "rtl", [U, n] = o([]), Y = () => /* @__PURE__ */ l.jsx(
    N,
    {
      animation: "wave",
      color: "gray",
      variant: "circle",
      height: 48,
      width: 48
    }
  ), Z = () => A ? /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsx(
      N,
      {
        width: 50,
        height: 16,
        animation: "wave",
        color: "gray",
        variant: "rectangle"
      }
    ),
    /* @__PURE__ */ l.jsx(
      N,
      {
        width: 50,
        height: 16,
        animation: "wave",
        color: "gray",
        variant: "rectangle"
      }
    )
  ] }) : (f == null ? void 0 : f.badges) && /* @__PURE__ */ l.jsx(
    p,
    {
      size: "small",
      ...f
    }
  ), _ = (e, i, a, g) => e ? /* @__PURE__ */ l.jsx(
    T,
    {
      ...e.tooltipProps,
      trigger: /* @__PURE__ */ l.jsx(
        K,
        {
          color: a,
          variant: g,
          size: i,
          iconOnly: e == null ? void 0 : e.iconOnly,
          leadingIcon: e == null ? void 0 : e.leadingIcon,
          trailingIcon: e == null ? void 0 : e.trailingIcon,
          label: e == null ? void 0 : e.label,
          onClick: e == null ? void 0 : e.onClick,
          disabled: e == null ? void 0 : e.disabled,
          loading: e == null ? void 0 : e.loading,
          testId: e == null ? void 0 : e.testId,
          badge: e == null ? void 0 : e.badge
        }
      )
    }
  ) : null, S = (e, i, a, g, h) => e && (e != null && e.dropdown) ? /* @__PURE__ */ l.jsx(
    T,
    {
      ...e.tooltipProps,
      trigger: /* @__PURE__ */ l.jsx(
        M,
        {
          position: "bottom-end",
          maxMenuHeight: 300,
          ...e.dropdown,
          onClose: () => {
            var j;
            (j = e.dropdown) != null && j.onClose && e.dropdown.onClose(), n((v) => v.filter((r) => r !== h));
          },
          dropDownElement: /* @__PURE__ */ l.jsx(
            K,
            {
              variant: g,
              color: a,
              size: i,
              iconOnly: e == null ? void 0 : e.iconOnly,
              leadingIcon: e == null ? void 0 : e.leadingIcon,
              trailingIcon: "chevron-down",
              label: e == null ? void 0 : e.label,
              testId: e == null ? void 0 : e.testId,
              disabled: e == null ? void 0 : e.disabled,
              className: w({
                [d.dropDownBtn]: U.includes(h)
              }),
              onClick: (j) => {
                var v;
                n((r) => r.includes(h) ? r : [...r, h]), (v = e == null ? void 0 : e.onClick) == null || v.call(e, j);
              }
            }
          )
        }
      )
    }
  ) : e ? _(e, i, a, g) : null, B = (e) => x && s ? /* @__PURE__ */ l.jsx(
    M,
    {
      maxMenuHeight: 315,
      offsetSize: 5,
      withPortal: !0,
      ...s,
      dropDownElement: /* @__PURE__ */ l.jsxs(
        "div",
        {
          className: "flex items-center gap-050 cursor-pointer pe-150",
          role: "button",
          tabIndex: 0,
          onClick: () => n((i) => i.includes(e) ? i : [...i, e]),
          onKeyDown: (i) => {
            (i.key === "Enter" || i.key === " ") && n((a) => a.includes(e) ? a : [...a, e]);
          },
          children: [
            /* @__PURE__ */ l.jsx(
              z,
              {
                text: x,
                testId: F,
                variant: "interface/strong/l",
                textColor: "color/fg/default",
                className: "mb-200"
              }
            ),
            /* @__PURE__ */ l.jsx(
              "div",
              {
                className: w("flex", {
                  [d.dropDownBtn]: U.includes(e)
                }),
                children: /* @__PURE__ */ l.jsx(
                  C,
                  {
                    name: "chevron-down",
                    size: "md"
                  }
                )
              }
            )
          ]
        }
      ),
      onClose: () => {
        s != null && s.onClose && s.onClose(), n((i) => i.filter((a) => a !== e));
      }
    }
  ) : x ? /* @__PURE__ */ l.jsx(
    z,
    {
      text: x,
      testId: F,
      variant: "interface/strong/l",
      textColor: "color/fg/default",
      className: "mb-200 pe-200"
    }
  ) : null, G = () => A ? /* @__PURE__ */ l.jsx(
    N,
    {
      width: 150,
      height: 16,
      animation: "wave",
      color: "white",
      variant: "rectangle"
    }
  ) : y && y.length > 0 && /* @__PURE__ */ l.jsx("div", { className: "flex items-center gap-100 ", children: y.map((e, i) => /* @__PURE__ */ l.jsxs(
    "div",
    {
      className: "flex items-center gap-050",
      children: [
        (e == null ? void 0 : e.icon) && /* @__PURE__ */ l.jsx(
          C,
          {
            size: "xxs",
            name: e.icon,
            className: d.iconSubtitle
          }
        ),
        /* @__PURE__ */ l.jsx(
          z,
          {
            text: e.text,
            variant: "interface/default/s",
            textColor: "color/fg/lighter"
          }
        )
      ]
    },
    i
  )) }), L = () => /* @__PURE__ */ l.jsx("div", { className: d.avatarEditContainer, children: q ? k || /* @__PURE__ */ l.jsx(l.Fragment, { children: /* @__PURE__ */ l.jsxs(
    "label",
    {
      htmlFor: "avatarUpload",
      style: { cursor: "pointer" },
      children: [
        /* @__PURE__ */ l.jsx(
          W,
          {
            size: "l",
            imageSrc: I,
            imageAlt: "profile-image"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "input",
          {
            id: "avatarUpload",
            type: "file",
            accept: "image/*",
            autoComplete: J,
            onChange: V
          }
        ),
        /* @__PURE__ */ l.jsx("div", { className: d.avatarEdit, children: /* @__PURE__ */ l.jsx(
          C,
          {
            styles: { fill: "white", color: "white" },
            name: "pencil-01"
          }
        ) })
      ]
    }
  ) }) : /* @__PURE__ */ l.jsx(
    W,
    {
      size: "l",
      imageSrc: I,
      imageAlt: "profile-image"
    }
  ) });
  return /* @__PURE__ */ l.jsxs("div", { className: d.pageHeaderWrapper, children: [
    /* @__PURE__ */ l.jsxs(
      "div",
      {
        className: w(d.pageHeaderContainer, $),
        ...X,
        children: [
          (c || (m == null ? void 0 : m.length)) && /* @__PURE__ */ l.jsxs("div", { className: "flex mb-150", children: [
            c && /* @__PURE__ */ l.jsx(
              "div",
              {
                "data-testId": c == null ? void 0 : c.testId,
                className: "flex items-center",
                children: /* @__PURE__ */ l.jsx(
                  C,
                  {
                    size: "xs",
                    styles: { color: "var(--ds-core-color-gray-modern-400)" },
                    name: R ? "arrow-right" : "arrow-left",
                    onClick: c == null ? void 0 : c.onClick,
                    className: w("!p-0 cursor-pointer", d.buttonClass)
                  }
                )
              }
            ),
            m == null ? void 0 : m.map((e, i) => /* @__PURE__ */ l.jsx(
              t,
              {
                text: e.text,
                iconName: e.iconName,
                isSelected: m.length - 1 === i,
                isRtl: R,
                onClick: e.onClick
              },
              i
            ))
          ] }),
          /* @__PURE__ */ l.jsxs("div", { className: "flex justify-between  items-start w-full", children: [
            /* @__PURE__ */ l.jsxs("div", { className: "flex gap-100", children: [
              A ? Y() : I && L(),
              /* @__PURE__ */ l.jsxs("div", { className: "flex flex-col justify-center gap-100", children: [
                /* @__PURE__ */ l.jsxs("div", { className: "flex align-middle", children: [
                  B("menu"),
                  /* @__PURE__ */ l.jsx("div", { className: "flex gap-100 mt-025", children: Z() })
                ] }),
                G()
              ] })
            ] }),
            /* @__PURE__ */ l.jsxs("div", { className: "flex gap-100 items-center", children: [
              !!O && S(O, "small", "primary", "filled", "primary"),
              !!E && S(
                E,
                "small",
                "neutral",
                "outlined",
                "secondary"
              ),
              !!H && S(H, "small", "neutral", "outlined", "menu")
            ] })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ l.jsx("div", { children: Q })
  ] });
}, fe = D(u);
export {
  fe as default
};
//# sourceMappingURL=PageHeader.js.map
